import PropTypes from 'prop-types';
import React from 'react';
import {
  IconButton
} from '@material-ui/core';

const iconStyle = {
  width: 24,
  height: 24,
  color: '#333',
};

const CornerButton = ({
  children,
  zIndex = 1,
  ...props,
}) => (
  <IconButton
    iconstyle={iconStyle}
    style={{
      position: 'absolute',
      top: '0',
      left: '0',
      width: 48,
      height: 48,
      padding: 16,
      zIndex,
    }}
    {...props}
  >
    {children}
  </IconButton>
);

CornerButton.propTypes = {
  children: PropTypes.node,
  zIndex: PropTypes.number,
};

export default CornerButton;



// WEBPACK FOOTER //
// ./src/ondemand/components/CornerButton.js